export const DOCUMENT_TYPE = Object.freeze({
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  TELEPHONE: 'TELEPHONE'
})
